import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const AssignmentIcon = React.forwardRef<SVGSVGElement, IconProps>(function AssignmentIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="M19 4h-4.18C14.4 2.84 13.3 2 12 2s-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m2 14H7v-2h7zm3-4H7v-2h10zm0-4H7V8h10z"/>
        </IconBase>
    );
});
